<template>
  <div>

    <button
      class="c-screen-indicator"
      @click="openModal"
      style="margin-right: 150px"
    >
      Bekijk online spelers
    </button>
    <div ref="main">
      <div ref="content" class="modal-content" :class="{hidden: !show}">
        <div class="modal__header">
          <h1>{{onlineCount}} spelers online</h1>
          <p>{{className}}</p>
        </div>
        <div class="modal__content">
          <table class="contenttable">
            <thead>
            <tr>
              <th>Planeetnaam</th>
              <th>Teamleider</th>
              <th>Aantal spelers</th>
              <th><!-- acties --></th>
            </tr>
            </thead>
            <tbody>
              <TeamOverviewTeam
                v-for="team in teams"
                :team="team"
                :key="team.uuid"
                :online-students="onlineStudents"
                @electLeader="electLeader"
              />
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import StudentIndicator from "./StudentIndicator.vue";
import TeamOverviewTeam from "./TeamOverviewTeam.vue";

export default {
  name: "TeamsOverview",
  components: {TeamOverviewTeam, StudentIndicator},
  props: {
    classObj: {},
    teams: [],
  },
  data(){
    return {
      show: false,
      channel: {},
      onlineStudents: [],
    };
  },
  methods: {
    openModal(){
      this.show = true;
    },
    electLeader(team){
      window.axios.post(`/docent/class/${this.classObj?.uuid}/control/elect-team-leader/${team.uuid}`);
    },
    refreshMembers(){
      const members = this.channel?.subscription?.members?.members ?? {};
      this.onlineStudents = Object.keys(members).filter(x => members[x].profile_complete);
    }
  },
  computed: {
    onlineCount(){
      return this.onlineStudents.length;
    },
    className(){
      this.classObj?.name;
    },
  },
  created(){
      this.channel = window.channels.find(channel => /^presence-class/.test(channel.name));
      console.log('have channel', this.channel);

      this.channel.on('pusher:member_added', () => {
        this.refreshMembers();
      });
      this.channel.on('pusher:member_removed', () => {
        this.refreshMembers();
      });
      this.refreshMembers();
  },
  watch: {
    show(val){
      if(val){
        const elm = this.$refs.content;
        window.modal.openModalWithElement(elm, () => {
          this.$refs.main.appendChild(elm);
          this.show = false;
          console.log('set show to false');
        }, {
            'max-width': '900px',
            'max-height': 'calc(100vh - 60px)',
        });
      }
    }
  },
}
</script>

<style scoped>
.hidden {
  display: none;
}

.modal-content {
  overflow-x: auto;
}

tr:nth-child(2){

}
</style>
